import { BoardPermission, BoardType, BoardViewType } from "app/types";
import { GroupByTypeEnum } from "../../../types";
import { BoardSettingState, IBoardState } from "../types";

export const defaultBoardForm: IBoardState = {
  _id: "",
  name: "",
  description: "",
  viewType: BoardViewType.KANBAN,
  moreDetails: {
    owner: {
      _id: "",
      name: "",
    },
    createdAt: "",
  },
  groupBy: GroupByTypeEnum.NONE,
  visibleGroups: [],
  subGroupBy: GroupByTypeEnum.NONE,
  customizeCards: [],
  permission: BoardPermission.PUBLIC,
  permissionUser: [] as [],
  defaultTicketValues: "",
  defaultTicketType: "",
  Type: BoardType.Custom,
  groups: [],
};

export const initialState: BoardSettingState = {
  isBoardCreate: false,
  isBoardLoading: false,
  boardForm: { ...defaultBoardForm },
  draftBoardForm: { ...defaultBoardForm },
};
